import { render } from "./Peu.vue?vue&type=template&id=0455c86b&scoped=true"
import script from "./Peu.vue?vue&type=script&lang=js"
export * from "./Peu.vue?vue&type=script&lang=js"

import "./Peu.vue?vue&type=style&index=0&id=0455c86b&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0455c86b"]])

export default __exports__